import { Box, Card, CardContent, Tooltip, Typography } from '@material-ui/core';
import StatisticCard from '@/components/Cards/StatisticCard';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useSelector } from 'react-redux';
import { blurSelector } from '@/redux';
import clsx from 'clsx';
import { SimpleStatisticCard } from '@/components/Cards';
import { Grid } from '@mui/material';
import useTaxesCard from './useTaxesCard';
import useStyles from './styles';

const TaxesCard = (): JSX.Element => {
  const styles = useStyles();
  const {
    expectedTaxes,
    preciseTaxAmountUah,
    targetDateStr,
    helpMessage,
    previousQuarterString,
    nearestTaxEvents,
  } = useTaxesCard();

  const isBlured = useSelector(blurSelector);

  return (
    <Card className={clsx(styles.root)}>
      <Box className={styles.header}>
        <Typography component="h4" className={styles.title}>
          Taxes
        </Typography>
        {nearestTaxEvents.length > 0 && (
          <Tooltip title="The amounts below are written without taking into account the bank commission.">
            <HelpOutlineIcon />
          </Tooltip>
        )}
      </Box>
      <Grid container spacing={1}>
        {nearestTaxEvents.length > 0 ? (
          <>
            {nearestTaxEvents.map((taxEvent) => (
              <Grid item xs={12} key={`tax-event-${taxEvent.id}`}>
                <div className={styles.content}>
                  <Typography>
                    Exact amount of{' '}
                    <Box component="span" className={styles.taxTypeLabel}>
                      {taxEvent.taxType ?? 'Single Tax'}
                    </Box>{' '}
                    to be paid for {previousQuarterString}:
                  </Typography>
                  <Typography
                    component="span"
                    className={clsx(styles.value, { [styles.blured]: isBlured })}
                  >
                    {taxEvent.amountUah}
                    <Box component="span" className={styles.label}>
                      UAH
                    </Box>
                  </Typography>
                  <Typography className={styles.dueDate}>
                    Due date: {new Date(taxEvent.targetDate).toLocaleDateString()}
                  </Typography>
                </div>
              </Grid>
            ))}
          </>
        ) : (
          <Grid item xs={12}>
            <div className={styles.content}>
              <Typography>There are no active Tax Events for you.</Typography>
            </div>
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default TaxesCard;
